var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoitems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NO_items",
    "data-name": "NO items",
    transform: "translate(-1111 -1397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1010",
    "data-name": "Rectangle 1010",
    width: 182,
    height: 182,
    transform: "translate(1111 1397)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(1117.131 1427.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M189.452,138.521a5.255,5.255,0,0,0-9.333-.13L145.19,203.557l-23.8-36.883a5.213,5.213,0,0,0-8.758,0L70.927,231.84a5.272,5.272,0,0,0,4.379,8.055h156.4a5.357,5.357,0,0,0,4.666-7.664Z",
    transform: "translate(-70.134 -117.382)",
    fill: "#366eef",
    opacity: 0.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M242.21,121.3a23.46,23.46,0,1,0-16.588-6.871A23.457,23.457,0,0,0,242.21,121.3Zm0-36.493a13.031,13.031,0,1,1-9.217,3.817A13.039,13.039,0,0,1,242.21,84.807Z",
    transform: "translate(-174.476 -74.38)",
    fill: "#cedcfb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoitems);
export default __webpack_public_path__ + "static/media/Noitems.d3375af57e6649fcbf807766770affaf.svg";
export { ForwardRef as ReactComponent };